module.exports = __webpack_public_path__ + "img/tezos_logo.23df4693.png";